import React, { useRef, useState } from "react";
import { Textarea } from "../ui/textarea";
import { Button } from "../ui/button";
import { Pick } from "../loans/LoanFormDialog";
import { TYPES, TYPE_LABEL, SAMPLE_VALUES, fill, toMeta } from "./constants";
import { Loader2 } from "lucide-react";

export const TemplatesPanel = ({ s, setS, placeholders, onSave, saving }) => {
  const [lang, setLang] = useState(s.language);
  const [type, setType] = useState("before_1");
  const ref = useRef(null);
  const text = s.templates[lang][type];
  const setText = (v) => setS((p) => ({ ...p, templates: { ...p.templates, [lang]: { ...p.templates[lang], [type]: v } } }));
  const insert = (ph) => {
    const el = ref.current; const tok = `{${ph}}`;
    const at = el ? el.selectionStart : text.length;
    setText(text.slice(0, at) + tok + text.slice(at));
  };

  return (
    <div className="grid gap-5 lg:grid-cols-2" data-testid="reminder-templates-panel">
      <div className="space-y-3 rounded-2xl border border-emerald-950/10 bg-white p-4">
        <div className="grid grid-cols-2 gap-3">
          <Pick testId="template-language" value={lang} onChange={setLang} options={[{ value: "bn", label: "বাংলা" }, { value: "en", label: "English" }]} />
          <Pick testId="template-type" value={type} onChange={setType} options={TYPES.map((t) => ({ value: t, label: TYPE_LABEL[t] }))} />
        </div>
        <Textarea ref={ref} rows={7} value={text} onChange={(e) => setText(e.target.value)} className="text-sm" data-testid="template-text" />
        <div className="flex flex-wrap gap-1.5">
          {placeholders.map((p) => (
            <button key={p} type="button" onClick={() => insert(p)} data-testid={`template-insert-${p}`}
              className="rounded-full border border-emerald-900/20 bg-emerald-50 px-2 py-0.5 font-mono text-[11px] text-emerald-900 hover:bg-emerald-100">{`{${p}}`}</button>
          ))}
        </div>
        <div className="text-[11px] text-emerald-900/50">{text.length} / 1024 characters</div>
        <Button onClick={onSave} disabled={saving} className="bg-[#0F4C3A] text-white hover:bg-emerald-900" data-testid="template-save">
          {saving && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}Save templates
        </Button>
      </div>
      <div className="space-y-4">
        <div className="rounded-2xl border border-emerald-950/10 bg-[#E7F7EF] p-4">
          <div className="mb-2 text-xs font-semibold uppercase tracking-wider text-emerald-900/60">Preview (example values, not a real member)</div>
          <div className="whitespace-pre-wrap rounded-xl bg-white p-3 text-sm text-emerald-950 shadow-sm" data-testid="template-preview">{fill(text, SAMPLE_VALUES)}</div>
        </div>
        <div className="rounded-2xl border border-emerald-950/10 bg-white p-4">
          <div className="mb-2 text-xs font-semibold uppercase tracking-wider text-emerald-900/60">Text to submit to Meta for approval</div>
          <div className="whitespace-pre-wrap font-mono text-xs text-emerald-900" data-testid="template-meta-body">{toMeta(text)}</div>
          <p className="mt-2 text-[11px] text-emerald-900/50">WhatsApp only allows business-started messages that use a template Meta has approved. Submit this text as a Utility template and enter its name in Settings.</p>
        </div>
      </div>
    </div>
  );
};
